module.exports = "<Form.Control type=\"text\" placeholder=\"Readonly input here...\" readOnly />;\n"